import { Box, Divider, IconButton, Typography, useTheme } from "@mui/material"
import logo from '../../resources/logo192.png'
import { useTranslation } from "react-i18next"
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { Link } from 'react-router-dom';
import Grid from '@mui/material/Grid2';
import { getAssetImagesUrl } from "../../api/ApiDataHelper";

export default function Footer(props) {
  const {
    // logo,
    links,
    sticky
  } = props

  const theme = useTheme()
  const { t } = useTranslation();

  return (
    <Box sx={{
      width: "100%",
      mt: "auto",
      display: "flex",
      userSelect: "none",
      bottom: "0",
      position: sticky ? "sticky" : "relative",
      zIndex: 1000,
      [theme.breakpoints.down('md')]: {
        position: "relative",
      },
      "& .gradient-blur":{
        [theme.breakpoints.down('md')]: {
          display: "none",
        },
        zIndex: -1,
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        // transform: "rotate(180deg)",

        "& > div, &::before, &::after": {
          position: "absolute",
          inset: 0,
        },
      "&::before": {
        content: "''",
        zIndex: "1",
        backdropFilter: "blur(0.5px)",
        backdropFilter: "blur(0.25px)",
        mask: `linear-gradient(
          to bottom,
          rgba(0, 0, 0, 0) 0%,
          rgba(0, 0, 0, 1) 12.5%,
          rgba(0, 0, 0, 1) 25%,
          rgba(0, 0, 0, 0) 37.5%
        )`
      },
      "& > div:nth-of-type(1)": {
        zIndex: 2,
        backdropFilter: "blur(1px)",
        backdropFilter: "blur(0.5px)",
        mask: `linear-gradient(
          to bottom,
          rgba(0, 0, 0, 0) 12.5%,
          rgba(0, 0, 0, 1) 25%,
          rgba(0, 0, 0, 1) 37.5%,
          rgba(0, 0, 0, 0) 50%
        )`
      },
      "& > div:nth-of-type(2)": {
        zIndex: 3,
        backdropFilter: "blur(2px)",
        backdropFilter: "blur(1px)",
        mask: `linear-gradient(
          to bottom,
          rgba(0, 0, 0, 0) 25%,
          rgba(0, 0, 0, 1) 37.5%,
          rgba(0, 0, 0, 1) 50%,
          rgba(0, 0, 0, 0) 62.5%
        )`
      },
      "& > div:nth-of-type(3)": {
        zIndex: 4,
        backdropFilter: "blur(4px)",
        backdropFilter: "blur(2px)",
        mask: `linear-gradient(
          to bottom,
          rgba(0, 0, 0, 0) 37.5%,
          rgba(0, 0, 0, 1) 50%,
          rgba(0, 0, 0, 1) 62.5%,
          rgba(0, 0, 0, 0) 75%
        )`
      },
      "& > div:nth-of-type(4)": {
        zIndex: 5,
        backdropFilter: "blur(8px)",
        backdropFilter: "blur(4px)",
        mask: `linear-gradient(
          to bottom,
          rgba(0, 0, 0, 0) 50%,
          rgba(0, 0, 0, 1) 62.5%,
          rgba(0, 0, 0, 1) 75%,
          rgba(0, 0, 0, 0) 87.5%
        )`
      },
      "& > div:nth-of-type(5)": {
        zIndex: 6,
        backdropFilter: "blur(16px)",
        backdropFilter: "blur(8px)",
        mask: `linear-gradient(
          to bottom,
          rgba(0, 0, 0, 0) 62.5%,
          rgba(0, 0, 0, 1) 75%,
          rgba(0, 0, 0, 1) 87.5%,
          rgba(0, 0, 0, 0) 100%
        )`
      },
      "& > div:nth-of-type(6)": {
        zIndex: 7,
        backdropFilter: "blur(32px)",
        backdropFilter: "blur(16px)",
        mask: `linear-gradient(
          to bottom,
          rgba(0, 0, 0, 0) 75%,
          rgba(0, 0, 0, 1) 87.5%,
          rgba(0, 0, 0, 1) 100%
        )`
      },
      "&::after": {
        content: "''",
        zIndex: 8,
        backdropFilter: "blur(64px)",
        backdropFilter: "blur(32px)",
        mask: `linear-gradient(
          to bottom,
          rgba(0, 0, 0, 0) 87.5%,
          rgba(0, 0, 0, 1) 100%
        )`
      }
    },
    }} >
      <Grid container sx={{
        boxSizing: "border-box",
        width: "100%",
        margin: "0px"
      }} spacing={1}>

        <Grid
          size={{
            xs: 10
          }}
          offset={{
            xs: 1
          }}>
          <Divider />
        </Grid>

        <Grid
          size={{
            xs: 10,
            md: 10,
            lg: 10,
          }}
          offset={{
            md: 1
          }}
          sx={{
            p:1,
            display: "flex",
            gap: 1,
            alignItems: "center",
          }}>
          <Box sx={{
            display: "flex",
            alignItems: "center",
            height: "100%",
            img: {
              width: "100px",
              maxWidth: "100%",
              objectFit: "contain",
              objectPosition: "left center",
            }
          }}>
            <img src={logo} alt="Company Logo" />
          </Box>

          <Box sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
            flexGrow: 2,
            [theme.breakpoints.up('lg')]: {
              // flexDirection: "row",
              // alignItems: "flex-end",
              // justifyContent: "flex-start",
              gap: 0,
            }
          }}>
            <Typography variant="body1" sx={{
              mb: 0,
            }}>
              <strong>
                {"Francesco Giannuzzi"}
              </strong>
            </Typography>
            <Box sx={{
              display: "flex",
              gap: 1,
              alignItems: "center",
              justifyContent: "baseline"
            }}>
              <Typography variant="body1">
                {"@gianoseduto"}
              </Typography>
              <IconButton name="linkedin link" component={Link} to="https://www.linkedin.com/in/francesco-giannuzzi-907159106/" target="blank" >
                <LinkedInIcon color="black" />
              </IconButton>
            </Box>
            <Box sx={{
            display: "flex",
            width: "100%",
            // justifyContent: "flex-end",
            alignItems: "flex-end",
            justifyContent: "flex-end",
            gap: 1,
            img: {
              width:"30px",
              height: "30px",
              display: "flex",
            }
          }}>
          <Typography sx={{
            fontSize: '8px',
            }}>
          {t("label_version")}:
          {process.env.REACT_APP_VERSION}
          </Typography>
          <img src={getAssetImagesUrl("gianoseduto_logo.gif")} alt="gianoeduto gif logo" />
          </Box>
          </Box>
        </Grid>

        {/* <Grid xs={7} md={4} lg={2} xsOffset={1.3} mdOffset={0}> */}
        {/* {textSecondColumn.split("\n").map((line, i) => {
          return (<Typography key={"secondColumn_line_" + i} variant="body1">
            {line}
          </Typography>)
        })
        } */}
        {/* </Grid> */}

        <Grid
        sx={{
          display: "none",
          flexDirection: "column",
          p: 1,
        }}
          size={{
            xs: 10,
            md: 4,
            lg: 3,
          }}
          offset={{
            lg: 0,
            xs: 1
          }}>
          <Box sx={{
            display: "flex",
            flexDirection: "row",
            textAlign: "right",
            gap: 2,
            justifyContent: "flex-end",
            alignItems: "flex-end",
            flexGrow: 2,
            pb: 1,
            "& a": {
              textDecoration: "none",
              color: theme.palette.text.primary
            },
          }}>
            {
              links?.map((link, i) => {

                return <Link key={"link_number_" + i} variant="body1" to={link.src} target="blank">
                  {link.label}
                </Link>
              })
            }
          </Box>
        </Grid>
        {/* <Grid xs={5} lg={1} xsOffset={1} lgOffset={0}>
          <Box sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
            img: {
              maxWidth: "100%",
              objectFit: "contain",
              maxHeight: "20px",
              objectPosition: "left center"
            }
          }}>
            <img src={logo} alt="gianoseduto logo" />
            <Typography variant="body2">made by <br></br> gianoseduto</Typography>
          </Box>
        </Grid> */}
      </Grid>
      <Box
        className="gradient-blur"
      >
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </Box>
    </Box>
  )
}
